function cssLoaded(callback, timeout) {
    setTimeout(function () {
        callback();
    }, timeout);
}